import { CompanyTypes } from 'EstraSuppliers'

type DateInput = Date | null

export type ProfileFormValues = {
  // Azienda
  company_name: string
  company_type?: CompanyTypes
  company_fiscal_code: string
  company_vat: string
  company_activity: string
  company_cciaa_nr: string
  company_cciaa_date: DateInput
  company_date_start: DateInput
  company_minimum_tax: boolean
  flat_rate_vat: boolean // regime_iva_forfettario
  company_withholding_tax: string

  // Contatti
  company_address_street: string
  company_address_number: string
  company_postal_code: string
  company_province_id: string
  company_city_id: string
  phone: string
  company_mobile_number: string
  company_fax_number: string
  company_pec: string
  email: string

  // Certificazioni
  company_dm_letters: string
  standard_iso_9001: boolean
  standard_iso_14001: boolean
  standard_ohsas18001: boolean
  standard_iso_45001: boolean
  standard_iso_iec_27001: boolean
  standard_sa8000: boolean
  standard_other: string

  // Indirizzo Corrispondenza
  fill_company_secondary_address: boolean
  company_secondary_address_street: string
  company_secondary_address_number: string
  company_secondary_postal_code: string
  company_secondary_province_id: string
  company_secondary_city_id: string

  // Titolare
  holder_address: PersonHolderFields
  // Direttore tecnico
  fill_technical_director: boolean
  technical_director_address: PersonHolderFields
  // Responsabile tecnico
  fill_technical_manager: boolean
  technical_manager_address: PersonHolderFields

  // Coordinate bancarie
  bank_account_1: BankAccount
  fill_secondary_bank_account: boolean
  bank_account_2: BankAccount

  // Privacy
  privacy_required: boolean
  privacy_optional_internal_marketing: Maybe<boolean>
  privacy_optional_external_marketing: Maybe<boolean>
}

type PersonHolderFields = {
  name: string
  surname: string
  fiscal_code: string
  birth_date: DateInput
  birth_place: string
  address_street: string
  address_number: string
  postal_code: string
  province_id: string
  city_id: string
}

type BankAccount = {
  bank: string
  agency: string
  iban: string
  delegated_name: string
  delegated_surname: string
  delegated_fiscal_code: string
  delegated_role: string
}

export const holderEmptyValues: PersonHolderFields = {
  name: '',
  surname: '',
  fiscal_code: '',
  birth_date: null,
  birth_place: '',
  address_street: '',
  address_number: '',
  postal_code: '',
  province_id: '',
  city_id: '',
}

const bankAccountEmptyValues: BankAccount = {
  bank: '',
  agency: '',
  iban: '',
  delegated_name: '',
  delegated_surname: '',
  delegated_fiscal_code: '',
  delegated_role: '',
}

export const formEmptyValues: ProfileFormValues = {
  // Azienda
  company_name: '',
  company_type: undefined,
  company_fiscal_code: '',
  company_vat: '',
  company_activity: '',
  company_cciaa_nr: '',
  company_cciaa_date: null,
  company_date_start: null,
  company_minimum_tax: false,
  flat_rate_vat: false,
  company_withholding_tax: '',

  // Contatti
  company_address_street: '',
  company_address_number: '',
  company_postal_code: '',
  company_province_id: '',
  company_city_id: '',
  phone: '',
  company_mobile_number: '',
  company_fax_number: '',
  company_pec: '',
  email: '',
  company_dm_letters: '',

  // Certificazioni
  standard_iso_9001: false,
  standard_iso_14001: false,
  standard_ohsas18001: false,
  standard_iso_45001: false,
  standard_iso_iec_27001: false,
  standard_sa8000: false,
  standard_other: '',

  // Indirizzo Corrispondenza
  fill_company_secondary_address: false,
  company_secondary_address_street: '',
  company_secondary_address_number: '',
  company_secondary_postal_code: '',
  company_secondary_province_id: '',
  company_secondary_city_id: '',

  // Titolare
  holder_address: {
    ...holderEmptyValues,
  },
  fill_technical_director: false,
  technical_director_address: {
    ...holderEmptyValues,
  },
  fill_technical_manager: false,
  technical_manager_address: {
    ...holderEmptyValues,
  },

  // Coordinate bancarie
  bank_account_1: { ...bankAccountEmptyValues },
  fill_secondary_bank_account: false,
  bank_account_2: { ...bankAccountEmptyValues },

  // Privacy
  privacy_required: false,
  privacy_optional_internal_marketing: null, // As Default these checkboxes are not selected
  privacy_optional_external_marketing: null,
}
